import React from 'react';
import Select from 'react-select';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';


export default class SupervisorScreen extends React.Component {

    constructor(props) {
        super(props);
        var regionid = null;

        if (props.args.region)  {
            regionid = props.args.region
        }

        this.state = {regionOptions: [], 
                      regionid: regionid,   
                      currentSupervisor: {id: null, 
                                         firstname: "",
                                         surname: "", 
                                         email: "",
                                         regionid: null,
                                         region: ""}};

        this.handleChangeFirstname = this.handleChangeFirstname.bind(this);  
        this.handleChangeSurname = this.handleChangeSurname.bind(this);  
        this.handleChangeEmail = this.handleChangeEmail.bind(this);  
        this.handleChangeRegion = this.handleChangeRegion.bind(this);
        this.save = this.save.bind(this);                         
    }

    async componentDidMount() {

        if (this.props.args.supervisor && this.props.args.supervisor.length > 0) {
            BaseApi.get("/supervisor", {headers: {
                'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {id: this.props.args.supervisor}, withCredentials: true})
            .then(res => { 
                this.setState({currentSupervisor: res.data})
            })    
            .catch()
        }

        BaseApi.get("/regions", {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => { 
            const regionOptions = res.data.map(({id, name}) => ({value: id, label: name}))
            this.setState({regionOptions: regionOptions})
        })    
        .catch()
    }


    save(event) {
        BaseApi.post('/supervisor', this.state.currentSupervisor, {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            this.props.goback(this.props.args)
        })
        .catch(error=>console.log(error))
        
        event.preventDefault();
    }

    handleChangeFirstname(event) {
        var currentSupervisor = this.state.currentSupervisor
        currentSupervisor.firstname = event.target.value
        this.setState({currentSupervisor: currentSupervisor})
    }

    handleChangeSurname(event) {
        var currentSupervisor = this.state.currentSupervisor
        currentSupervisor.surname = event.target.value
        this.setState({currentSupervisor: currentSupervisor})
    }
    
    handleChangeEmail(event) {
        var currentSupervisor = this.state.currentSupervisor
        currentSupervisor.email = event.target.value
        this.setState({currentSupervisor: currentSupervisor})
    }    

    handleChangeRegion(selectedOption) {
        var currentSupervisor = this.state.currentSupervisor
        currentSupervisor.region = selectedOption.label
        currentSupervisor.regionid = selectedOption.value
        this.setState({currentSupervisor: currentSupervisor})
    }

    render() {

        return (
            <div class="container">

                <ScreenCaption goback={this.props.goback} args={this.props.args} caption={"Куратор"}/>

                <div class="row mt-4">
                    <div class="col-lg-8">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">
                                    {this.state.currentSupervisor.id ? "Редактирование куратора" : "Новый куратор"}
                                </h6>

                                <form>
                                    <div class="form-group">
                                    <label for="name">Имя:</label>
                                    <input type="text" class="form-control" id="name" value={this.state.currentSupervisor.firstname} onChange={this.handleChangeFirstname} />
                                    <label for="surname">Фамилия:</label>
                                    <input type="text" class="form-control" id="surname" value={this.state.currentSupervisor.surname} onChange={this.handleChangeSurname} />
                                    <label for="email">Email:</label>
                                    <input type="text" class="form-control" id="email" value={this.state.currentSupervisor.email} onChange={this.handleChangeEmail} />
                                    <label for="region">Регион:</label>
                                    {this.state.regionid === null && 
                                        <Select options= {this.state.regionOptions} 
                                                id="region" 
                                                onChange={this.handleChangeRegion}
                                                placeholder={this.state.currentSupervisor.region}    
                                                />
                                    }
                                    {this.state.regionid !== null &&  
                                        <input type="text" class="form-control w-100" id="region" value={this.state.currentSupervisor.region} readonly="readonly"/>      
                                    }        
                                    </div>
                                </form>
                                <div className="mt-4 d-flex justify-content-end">
                                    <button type="submit" className="btn btn-primary" onClick={this.save}>
                                        Сохранить
                                    </button>
                                </div>
                                
                            </div>
                        </div>    
                    </div>
                </div>
            </div> 
        )
    }

}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/supervisor.js